import { mutationTypes, errorTypes } from '../../../types';
import intersectionWith from 'lodash/intersectionWith';
import { logger } from '../../../tools/logger';
import errorHandler from '../../../tools/errorHandler';
import { PACKAGE_SYNCER_ACTIONS } from '../../../tools/consts';

function intersection(array1, array2) {
	return intersectionWith(array1, array2, (x, y) => x.name === y.name && x.version === y.version);
}
window.intersection = intersection;
export default {
	/**
	 * This mutations sets app into syncer mode
	 * @param { } state
	 */
	[mutationTypes.packageSyncerSetIsSyncerApp](state, { mode, subParts, initialPackages }) {
		state.isActive = true;
		state.mode = mode;
		state.subParts = subParts;
		state.initialPackages = initialPackages;
	},
	/**
	 *	Sets packages to install
	 * @param { * } state
	 * @param { packages } packages
	 */
	[mutationTypes.packageSyncerSetInstalledPackages](state, { packages }) {
		state.packagesInstalled = packages;
		Object.values(state.subParts).forEach(subPart => {
			subPart.packagesInstalled = intersection(subPart.packagesGoal, packages);
		});
		// state.subParts = { ...state.subParts };
	},
	/**
	 *	Sets allready installed packages
	 * @param { * } state
	 * @param { packages } packages
	 */
	[mutationTypes.packageSyncerSetPackageGoal](state, { packages }) {
		logger.log('packageSyncer: Goal repository is,', packages);
		state.packagesGoal = packages;
	},

	/**
	 * This mutation commited by native package syncer progress event
	 * @param { } state
	 * @param { appsProcessed, appsTotal, error } progress informations
	 */
	[mutationTypes.packageSyncerSetProgress](state, { appsProcessed, appsTotal, error }) {
		state.packagesProcessed = appsProcessed;
		state.packagesTotal = appsTotal;
		state.error = error;
	},
	/**
	 * This mutation updates sycronisation state of the native packagesycer module
	 * also if isSyncing is false it infers syncing process is finished. packagesGoal
	 * will be packagesInstalled
	 * @param {*} state
	 * @param { isSyncing } parameters
	 **/
	[mutationTypes.packageSyncerSetSycronisationState](state, { isSyncing }) {
		if (!isSyncing) {
			state.packagesInstalled = state.packagesGoal;
			state.packagesGoal = state.packagesGoal;
			state.currentAction = null;
		}
		state.isSyncing = isSyncing;
	},
	/**
	 * @param {*} state
	 */
	[mutationTypes.packageSyncerNextActionInQueue](state) {
		state.currentAction = state.actionQueue.shift();
		state.actionQueue = [...state.actionQueue];

		if (state.subParts[state.currentAction.subPartID]) {
			// set subPart isSelected value depending on current action
			state.subParts[state.currentAction.subPartID].isSelected =
				state.currentAction.action === PACKAGE_SYNCER_ACTIONS.download;
			// save selection of subparts to localStorage
			localStorage.packageSyncerSelectedSubParts = JSON.stringify(
				Object.entries(state.subParts).reduce((acc, entrie) => {
					acc[entrie[0]] = entrie[1].isSelected;
					return acc;
				}, {})
			);
		} else {
			errorHandler(new Error(errorTypes.packageSyncerUnkownSubPart));
		}
	},

	[mutationTypes.packageSyncerErrorOccured](state, error) {
		state.errors.push(error);
	},

	[mutationTypes.packageSyncerCancel](state) {
		state.errors = [];
		state.subParts[state.currentAction.subPartID].isSelected = false;
		// if it is and delete action update installed packages so subPackages are updated and
		// user is not able to open maybe deleted articles
		if (state.currentAction.action === PACKAGE_SYNCER_ACTIONS.download) {
			state.packagesInstalled = state.packagesGoal;
			state.packagesGoal = state.packagesGoal;
		}
		localStorage.packageSyncerSelectedSubParts = JSON.stringify(
			Object.entries(state.subParts).reduce((acc, entrie) => {
				acc[entrie[0]] = entrie[1].isSelected;
				return acc;
			}, {})
		);
		state.currentAction = null;
		state.isSyncing = false;
		state.actionQueue = [];
	},

	[mutationTypes.packageSyncerPushToSubPartActionQueue](state, action) {
		state.actionQueue = [...state.actionQueue, action];
	},
};
